export default "__VITE_ASSET__5QoqFuWg__"